import { render, staticRenderFns } from "./registro-sucursal.vue?vue&type=template&id=71113ff6&"
import script from "./registro-sucursal.vue?vue&type=script&lang=js&"
export * from "./registro-sucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports